export default "__VITE_ASSET__7c5cff14__"